import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { Tag, TagLink } from '@saucelabs/ds-tag';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';
import { useDispatch } from 'react-redux';

import actions from '../actions';

type TableCellVersionProps = {
  group: appStorageRecords.AppStorageGroup
};

const TableCellVersion: React.FC<TableCellVersionProps> = ({ group }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const additionalVersions = group.getAdditionalVersionCount();

  return (
    <div className="flex flex-row">
      <Typography data-qa="app-management-groups-table-cell-version-label">
        {group.getMostRecentUploadVersion()}
      </Typography>

      {additionalVersions > 0 && (
        <Tag className="ml-1">
          <TagLink
            data-qa="app-management-groups-table-cell-version-tag-link"
            linkType="react-router-link"
            onClick={() => void dispatch(actions.setCurrentGroup(group))}
            to={`/app-management/groups/${group.id}`}
          >
            {`+${additionalVersions}`}
          </TagLink>
        </Tag>
      )}
    </div>
  );
};

export default TableCellVersion;
